// #region TypeDefs
// #region EnumsDefs
const PersonType = {
  /** @type {'F'} */ FISICA: 'F',
  /** @type {'J'} */ JURIDICA: 'J'
}
const ResidenceType = {
  /** @type {'R'} */ RESIDENTE: 'R',
  /** @type {'U'} */ EUROPEO: 'U',
  /** @type {'E'} */ EXTRANJERO: 'E'
}
// #endregion

// #region ClassDefs
// #region Facturae MainData
class FacturaeData {
  /** @type {number|null} */ IdCliente = null
  /** @type {Issuer} */ issuer = null
  /** @type {Receiver} */ receiver = null
  /** @type {string} */ serieFactura = null
  /** @type {string} */ numFactura = null
  /** @type {Date} */ dateEmision = null
  /** @type {string} */ albaran = null
  /** @type {string} */ pedido = null
  /** @type {string} */ observaciones = null
  /** @type {string} */ numExpediente = null
  /** @type {Date} */ dateExpediente = null
  /** @type {string} */ numEmisor = null
  /** @type {Date} */ dateEmisor = null
  /** @type {string} */ codAsignacion = null
  /** @type {Date} */ dateReceptor = null
  /** @type {string} */ dir3 = null
  /** @type {string} */ numContrato = null
  /** @type {string} */ codDepReceptor = null
  /** @type {TaxWithHeld} */ taxesWithHeld = null
  /** @type {number} */ cuotaSuplido = null
  /** @type {Date} */ periodoDesde = null
  /** @type {Date} */ periodoHasta = null
  /** @type {Array<InvoiceLine>} */ invoiceLines = null
  /** @type {PaymentMethod} */ paymentMethod = null
  /** @type {Array<File>} */ Adjuntos = null
  /** @type {number|null} */ idPlantilla = null
  /** @type {File|null} */ file = null
}
// #endregion

// #region Issuer (Seller)
class Issuer {
  /** @type {string} */ Direccion = null
  /** @type {string} */ Poblacion = null
  /** @type {string} */ CodigoPostal = null
  /** @type {string} */ Provincia = null
  /** @type {string} */ CodigoPais = null
  /** @type {string} */ Telefono = null
  /** @type {string} */ RazonSocial = null
  /** @type {string} */ PersonaFisicaNombre = null
  /** @type {string} */ PersonaFisicaPrimerApellido = null
  /** @type {string} */ PersonaFisicaSegundoApellido = null
  /** @type {string} */ CIF = null
  /** @type {'F'|'J'} */ PersonaFisica = PersonType.FISICA
  /** @type {'R'|'U'|'E'} */ TipoResidencia = ResidenceType.RESIDENTE
}
// #endregion

// #region Address
class Address {
  /** @type {string} */ AddressLine = null
  /** @type {string} */ PostCode = null
  /** @type {string} */ Town = null
  /** @type {string} */ Province = null
  /** @type {string} */ CountryCode = null
}
// #endregion

// #region Contact
class ContactDetails {
  /** @type {string} */ Telephone = null
  /** @type {string} */ TeleFax = null
  /** @type {string} */ WebAddress = null
  /** @type {string} */ ElectronicMail = null
  /** @type {string} */ INETownCode = null
  /** @type {string} */ ContactPersons = null
  /** @type {string} */ CnoCnae = null
  /** @type {string} */ AdditionalDetails = null
}
// #endregion

// #region Receptor (Buyer)
class Receiver {
  /** @type {Sociedad} */ Sociedad = null
  /** @type {string} */ LocationName = null
  /** @type {string} */ SendType = null
  /** @type {Address} */ Address = null
  /** @type {ContactDetails} */ ContactDetails = null
  /** @type {Array<AdminsitrativeCentre>} */ AdminsitrativeCentres = null
  /** @type {FACeB2BIdentificatives} */ FACeB2BIdentificatives = null
  /** @type {Array<AdminsitrativeCentreFACeB2B>} */ AdminsitrativeCentresFACeB2B = null
}

// #region Sociedad
class Sociedad {
  /** @type {boolean} */ IsSeflInvoiceSociety = true
  /** @type {string} */ TIN = null
  /** @type {string} */ ResidenceType = null
  /** @type {string} */ PersonType = null
  /** @type {string} */ NameCorporateName = null
  /** @type {string} */ FirstSurname = null
  /** @type {string} */ SecondSurname = null
  /** @type {RegistrationData} */ RegistrationData = null
}

// #region RegData
class RegistrationData {
  /** @type {string} */ Book = null
  /** @type {string} */ RegisterOfCompaniesLocation = null
  /** @type {string} */ Sheet = null
  /** @type {string} */ Folio = null
  /** @type {string} */ Section = null
  /** @type {string} */ Volume = null
  /** @type {string} */ AdditionalData = null
}
// #endregion
// #endregion

// #region AdmCenters
// #region AdmCenter FACe
class AdminsitrativeCentre {
  /** @type {string} */ CentreCode = null
  /** @type {string} */ RoleCode = null
  /** @type {string} */ Name = null
  /** @type {string} */ FirstSurname = null
  /** @type {string} */ SecondSurname = null
  /** @type {Address} */ Address = null
  /** @type {ContactDetails} */ ContactDetails = null
  /** @type {string} */ PhysicalIGLN = null
  /** @type {string} */ LogicalOperationalPoint = null
  /** @type {string} */ CentreDescription = null
}
// #endregion

// #region FACe B2B
// #region Identificatives
class FACeB2BIdentificatives {
  /** @type {string} */ DIRE = null
  /** @type {string} */ Name = null
}
// #endregion

// #region AdmCenter FACe B2B
class AdminsitrativeCentreFACeB2B {
  /** @type {string} */ Code = null
  /** @type {string} */ Name = null
  /** @type {string} */ Role = null
}
// #endregion
// #endregion
// #endregion
// #endregion

// #region Tax with held
class TaxWithHeld {
  /** @type {string} */ taxType = '04'
  /** @type {number} */ taxRate = null
  /** @type {number} */ cuota = null
}
// #endregion

// #region Lines
// #region Line
class InvoiceLine {
  /** @type {string} */ codProducto = null
  /** @type {string} */ descripcion = null
  /** @type {number} */ precioUnitario = null
  /** @type {number} */ cantidad = null
  /** @type {number} */ subtotal = null
  /** @type {number} */ total = null
  /** @type {string} */ UnitOfMeasure = null
  /** @type {number} */ totalConImpuesto = null
  /** @type {number} */ lineNumber = null
  /** @type {Descuento} */ descuentos = null
  /** @type {Array<Tax>} */ taxes = null
}
// #endregion

// #region Descuento
class Descuento {
  /** @type {number|null} */ descuento = null
  /** @type {number|null} */ cuota = null
}
// #endregion

// #region Tax
class Tax {
  /** @type {string} */ taxType = null
  /** @type {number} */ taxRate = null
  /** @type {number} */ cuota = null
}
// #endregion
// #endregion

// #region Payment
class PaymentMethod {
  /** @type {string} */ formaPago = null
  /** @type {string} */ iban = null
  /** @type {string} */ bicSwift = null
  /** @type {string} */ fechaMandato = null
  /** @type {boolean} */ toBeCredit = null
}
// #endregion

// #region File (File || Attachment)
class File {
  /** @type {string} */ Nombre = null
  /** @type {string} */ Mime = null
  /** @type {string} */ contenidoB64 = null
}
// #endregion
// #endregion
// #endregion

async function convertFileToBase64 (formFile) {
  if (formFile.raw) {
    const file = new File()
    file.contenidoB64 = await new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result.split(',')[1]) // Extraemos solo el base64 (sin el encabezado 'data:...')
      reader.onerror = (error) => reject(error)
      reader.readAsDataURL(formFile.raw) // Leemos el archivo como un DataURL
    })
    file.Nombre = formFile.Nombre
    file.Mime = formFile.Extension
    return file
  }
  return null
}

function getNullableNumber (value) {
  return value === 0 || value ? value : null
}

async function getPayloadFacturae (form, idCliente = null, includeFiles = true, overrideTemplate = null) {
  const payload = new FacturaeData()
  payload.IdCliente = idCliente
  payload.serieFactura = form.serieFactura || null
  payload.numFactura = form.numFactura || null
  payload.dateEmision = form.dateEmision || null
  payload.albaran = form.albaran || null
  payload.pedido = form.pedido || null
  payload.observaciones = form.observaciones || null
  payload.numExpediente = form.numExpediente || null
  payload.dateExpediente = form.dateExpediente || null
  payload.numEmisor = form.numEmisor || null
  payload.dateEmisor = form.dateEmisor || null
  payload.codAsignacion = form.codAsignacion || null
  payload.dateReceptor = form.dateReceptor || null
  payload.dir3 = form.dir3 || null
  payload.numContrato = form.numContrato || null
  payload.codDepReceptor = form.codDepReceptor || null
  payload.cuotaSuplido = form.cuotaSuplido || null
  payload.periodoDesde = form.periodoDesde || null
  payload.periodoHasta = form.periodoHasta || null
  //   payload.tipoImpuesto = form.tipoImpuesto || null // TODO -> ¿Qué es?
  //   payload.tipoAsociado = form.tipoAsociado || null // TODO -> ¿Qué es?
  //   payload.fechaAplicacion = form.fechaAplicacion || null // TODO -> ¿Qué es?
  payload.idPlantilla = (overrideTemplate || form.template)?.idPlantilla || null

  if (form.issuer) {
    const formIssuer = form.issuer
    const issuer = new Issuer()
    issuer.Direccion = formIssuer.Direccion || null
    issuer.Poblacion = formIssuer.Poblacion || null
    issuer.CodigoPostal = formIssuer.CodigoPostal || null
    issuer.Provincia = formIssuer.Provincia || null
    issuer.CodigoPais = formIssuer.CodigoPais || null
    issuer.Telefono = formIssuer.Telefono || null
    issuer.EmailTecnico = formIssuer.EmailTecnico || null
    issuer.certAsociado = formIssuer.certAsociado || null
    issuer.RazonSocial = formIssuer.RazonSocial || null
    issuer.PersonaFisicaNombre = formIssuer.PersonaFisicaNombre || null
    issuer.PersonaFisicaPrimerApellido = formIssuer.PersonaFisicaPrimerApellido || null
    issuer.PersonaFisicaSegundoApellido = formIssuer.PersonaFisicaSegundoApellido || null
    issuer.CIF = formIssuer.CIF || null
    issuer.PersonaFisica = formIssuer.PersonaFisica ? PersonType.FISICA : PersonType.JURIDICA
    issuer.TipoResidencia = formIssuer.TipoResidencia || ResidenceType.RESIDENTE   
    payload.issuer = issuer
  }

  if (form.receiver) {
    const formReceiver = form.receiver
    const receiver = new Receiver()
    receiver.SendType = formReceiver.SendType || null
    receiver.LocationName = formReceiver.LocationName || null

    if (formReceiver.Address) {
      const receiverAddress = formReceiver.Address
      const address = new Address()
      address.AddressLine = receiverAddress.Address || null
      address.PostCode = receiverAddress.PostCode || null
      address.Town = receiverAddress.Town || null
      address.Province = receiverAddress.Province || null
      address.CountryCode = receiverAddress.CountryCode || null
      receiver.Address = address
    }

    if (formReceiver.Sociedad) {
      const formSociedad = formReceiver.Sociedad
      const sociedad = new Sociedad()
      sociedad.AgendaGeneral = !!formSociedad.AgendaGeneral
      sociedad.IsSeflInvoiceSociety = !!formSociedad.IsSeflInvoiceSociety
      sociedad.TIN = formSociedad.TIN || null
      sociedad.ResidenceType = formSociedad.ResidenceType || 'R'
      sociedad.PersonType = formSociedad.PersonType || 'J'
      sociedad.NameCorporateName = formSociedad.NameCorporateName || null

      if (formSociedad.RegistrationData) {
        const formRegistrationData = formSociedad.RegistrationData
        const registrationData = new RegistrationData()
        registrationData.Book = formRegistrationData.Book || null
        registrationData.RegisterOfCompaniesLocation = formRegistrationData.RegisterOfCompaniesLocation || null
        registrationData.Sheet = formRegistrationData.Sheet || null
        registrationData.Folio = formRegistrationData.Folio || null
        registrationData.Section = formRegistrationData.Section || null
        registrationData.Volume = formRegistrationData.Volume || null
        registrationData.AdditionalData = formRegistrationData.AdditionalData || null
        sociedad.RegistrationData = registrationData
      }

      receiver.Sociedad = sociedad
    }

    if (formReceiver.ContactDetails) {
      const formContactDetails = formReceiver.ContactDetails
      const contactDetails = new ContactDetails()
      contactDetails.Telephone = formContactDetails.Telephone || null
      contactDetails.TeleFax = formContactDetails.TeleFax || null
      contactDetails.WebAddress = formContactDetails.WebAddress || null
      contactDetails.ElectronicMail = formContactDetails.ElectronicMail || null
      contactDetails.INETownCode = formContactDetails.INETownCode || null
      contactDetails.ContactPersons = formContactDetails.ContactPersons || null
      contactDetails.CnoCnae = formContactDetails.CnoCnae || null
      contactDetails.AdditionalDetails = formContactDetails.AdditionalDetails || null
      receiver.ContactDetails = contactDetails
    }

    if (formReceiver.CentrosAdministrativos?.length) {
      const formCentrosAdministrativos = formReceiver.CentrosAdministrativos
      receiver.AdminsitrativeCentres = receiver.AdminsitrativeCentres === null ? [] : receiver.AdminsitrativeCentres
      formCentrosAdministrativos.forEach(formCentroAdm => {
        const administrativeCenter = new AdminsitrativeCentre()
        administrativeCenter.CentreCode = formCentroAdm.CentreCode || null
        administrativeCenter.RoleCode = formCentroAdm.RoleCode || null
        administrativeCenter.Name = formCentroAdm.Name || null
        administrativeCenter.FirstSurname = formCentroAdm.FirstSurname || null
        administrativeCenter.SecondSurname = formCentroAdm.SecondSurname || null
        administrativeCenter.ContactDetails = formCentroAdm.ContactDetails || null
        administrativeCenter.PhysicalIGLN = formCentroAdm.PhysicalIGLN || null
        administrativeCenter.LogicalOperationalPoint = formCentroAdm.LogicalOperationalPoint || null
        administrativeCenter.CentreDescription = formCentroAdm.CentreDescription || null

        if (formCentroAdm.Address) {
          const admCenterAddress = formCentroAdm.Address
          const address = new Address()
          address.AddressLine = admCenterAddress.Address || null
          address.PostCode = admCenterAddress.PostCode || null
          address.Town = admCenterAddress.Town || null
          address.Province = admCenterAddress.Province || null
          address.CountryCode = admCenterAddress.CountryCode || null
          administrativeCenter.Address = address
        }
        receiver.AdminsitrativeCentres.push(administrativeCenter)
      })
    }

    if (formReceiver.CentrosAdministrativosFB2B?.length) {
      const formCentrosAdministrativosFB2B = formReceiver.CentrosAdministrativosFB2B
      receiver.AdminsitrativeCentresFACeB2B = receiver.AdminsitrativeCentresFACeB2B === null ? [] : receiver.AdminsitrativeCentresFACeB2B
      formCentrosAdministrativosFB2B.forEach(formCentroAdmFB2B => {
        const administrativeCenterFB2B = new AdminsitrativeCentreFACeB2B()
        administrativeCenterFB2B.Code = formCentroAdmFB2B.Code || null
        administrativeCenterFB2B.Name = formCentroAdmFB2B.Name || null
        administrativeCenterFB2B.Role = formCentroAdmFB2B.Role || null
        receiver.AdminsitrativeCentresFACeB2B.push(administrativeCenterFB2B)
      })
    }

    if (formReceiver.FACeB2BIdentificatives) {
      const formIdentificatives = formReceiver.FACeB2BIdentificatives
      const identificatives = new FACeB2BIdentificatives()
      identificatives.DIRE = formIdentificatives.DIRE || null
      identificatives.Name = formIdentificatives.Name || null
      receiver.FACeB2BIdentificatives = identificatives
    }
    payload.receiver = receiver
  }

  if (form.irpf) {
    const formIrpf = form.irpf
    const taxWithHeld = new TaxWithHeld()
    taxWithHeld.taxType = formIrpf.TaxType || '04'
    taxWithHeld.taxRate = getNullableNumber(formIrpf.TaxRate)
    payload.taxesWithHeld = taxWithHeld
  }

  if (form.invoiceLines?.length) {
    const formLines = form.invoiceLines
    payload.invoiceLines = []
    formLines.forEach(invoiceLine => {
      const line = new InvoiceLine()
      line.codProducto = invoiceLine.codProducto || null
      line.descripcion = invoiceLine.descripcion || null
      line.precioUnitario = getNullableNumber(invoiceLine.precioUnitario)
      line.cantidad = getNullableNumber(invoiceLine.cantidad)
      line.subtotal = getNullableNumber(invoiceLine.subtotal)
      line.total = getNullableNumber(invoiceLine.total)
      line.UnitOfMeasure = getNullableNumber(invoiceLine.UnitOfMeasure)
      line.totalConImpuesto = getNullableNumber(invoiceLine.totalConImpuesto)
      line.lineNumber = getNullableNumber(invoiceLine.lineNumber)
      if (invoiceLine.descuentos?.length) {
        const formDescuento = invoiceLine.descuentos[0]
        const descuento = new Descuento()
        descuento.descuento = (formDescuento.incluyeDescuento ? formDescuento.descuento : null) || null
        descuento.cuota = (formDescuento.incluyeDescuento ? null : formDescuento.cuota) || null
        if (formDescuento.incluyeDescuento ? (descuento.descuento || descuento.descuento === 0) : (descuento.cuota || descuento.cuota === 0)) {
          line.descuentos = descuento
        }
      }
      if (invoiceLine.taxes?.length) {
        const formTaxes = invoiceLine.taxes
        line.taxes = []
        formTaxes.forEach(lineTax => {
          const tax = new Tax()
          tax.taxType = lineTax.TaxType || null
          tax.taxRate = getNullableNumber(lineTax.TaxRate)
          tax.cuota = getNullableNumber(lineTax.cuota)
          line.taxes.push(tax)
        })
      }
      payload.invoiceLines.push(line)
    })
  }

  if (form.paymentMethod) {
    const formPaymentMethod = form.paymentMethod
    const paymentMethod = new PaymentMethod()
    paymentMethod.formaPago = formPaymentMethod.formaPago || null
    paymentMethod.iban = formPaymentMethod.iban || null
    paymentMethod.bicSwift = formPaymentMethod.bicSwift || null
    paymentMethod.fechaMandato = formPaymentMethod.fecha || null
    paymentMethod.toBeCredit = !!formPaymentMethod.toBeCredit
    payload.paymentMethod = paymentMethod
  }

  if (includeFiles) {
    const checkFile = form.file?.[0] ?? form.file
    if (checkFile && !Array.isArray(checkFile)) {
      payload.file = await convertFileToBase64(checkFile)
    }
    if (form.Adjuntos?.length) {
      payload.Adjuntos = await Promise.all(form.Adjuntos.map(file => convertFileToBase64(file)))
    }
  }
  return payload
}

export default getPayloadFacturae
